import { onMounted, onUnmounted } from 'vue'
import { bus, type BusEventListener, type BusEventName } from '@/utils/bus'

export function useEvent<K extends BusEventName>(key: K, callback: BusEventListener<K>) {
  onMounted(() => bus.$on(key, callback))
  onUnmounted(() => bus.$off(key, callback))
}
